import React, { useState, useEffect } from "react";
import 'chart.js/auto';
import { Line } from 'react-chartjs-2';
import useAxios from "../../helpers/useAxios";

const Valorizacao = (props) => {
  const [dataGraph, setDataGraph] = useState(null);
  const [graphType, setGraphType] = useState(2);
  const [isLoaded, setIsLoaded] = useState(false);

  const { fetch, data, error, loaded } = useAxios("POST", "/Funds/funds-valorization", { nif: props.nif, fund: parseInt(props.id), type: graphType });

  const graphFiveYears = () =>{
    setGraphType(1);

    setIsLoaded(false);

    fetch("POST", "/Funds/funds-valorization", { nif: props.nif, fund: parseInt(props.id), type: 1 });
  }

  const graphLastYear = () =>{
    setGraphType(2);

    setIsLoaded(false);

    fetch("POST", "/Funds/funds-valorization", { nif: props.nif, fund: parseInt(props.id), type: 2 });
  }

  const graphStartYear = () =>{
    setGraphType(3);

    setIsLoaded(false);

    fetch("POST", "/Funds/funds-valorization", { nif: props.nif, fund: parseInt(props.id), type: 3 });
  }

  useEffect(() => {
    setIsLoaded(false);

    fetch("POST", "/Funds/funds-valorization", { nif: props.nif, fund: parseInt(props.id), type: graphType });
  }, [props.id]);

  const options = {
    scales: {
      x: {
        grid: {
          display: false,
          borderColor: '#F2F4F8',
        },
        ticks: {
          color: "#3F5B78",
        },
      },
      y: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: "#3F5B78",
          callback: function(value, index, values) {
            return (Math.floor(value * 100) / 100 + " €").replace('.', ',');
        },
        },
      },
    },
    elements: {
      point: {
        radius: 0,
        pointStyle: 'rect',
        hitRadius: 6,
        hoverRadius: 6,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
  };

  const colors = ['#0071CE', '#003E71', '#6EB5FF', '#0071CE', '#003E71', '#6EB5FF', '#0071CE', '#003E71', '#6EB5FF', '#0071CE', '#003E71', '#6EB5FF', '#0071CE', '#003E71', '#6EB5FF'];
  
  useEffect(() => {
    if (loaded && error.length === 0) {
      setIsLoaded(true);

      const labels = data.label;

      let datasets = [];
      data.fundsValue.map((d, i) => {
        datasets.push({
          fill: false,
          data: d.value,
          label: d.fundName,
          borderColor: colors[i],
          backgroundColor: colors[i],
        })
      });

      const newData = {
        labels,
        datasets,
      };

      setDataGraph(newData);
    }
  }, [data]);

  return (
    <div className="col-md-6 mb-4 col-eq-h">
      <div className="col-md-12 bg-white rounded-4 p-3">
        <div className="row mb-4">
          <div className="col-4 my-auto">
            <h3 className="my-auto">Evolução da valorização</h3>
          </div>
          <div className="col-8 text-end">
            <button
              type="button" className={"btn btn-graph btn-graph-first " + (graphType === 1 ? 'btn-graph-active' : '')}
              onClick={() => graphFiveYears()}
            >
              Últimos 5 anos
            </button>
            <button
              type="button" className={"btn btn-graph " + (graphType === 2 ? 'btn-graph-active' : '')}
              onClick={() => graphLastYear()}
            >
              Último ano
            </button>
            <button
              type="button" className={"btn btn-graph btn-graph-last " + (graphType === 3 ? 'btn-graph-active' : '')}
              onClick={() => graphStartYear()}
            >
              Início do ano
            </button>
          </div>
        </div>
        <div style={{height:225}}>
        {!isLoaded && (
            <div className="text-center pt-5">
              <div className="spinner-border text-blue" role="status">
              </div>
            </div>
          )}
          {(isLoaded && dataGraph) && (
            <Line options={options} data={dataGraph} />
          )}
        </div>        
      </div>
    </div>
  );
};

export default Valorizacao;
